import Backbone from 'backbone'
import $ from 'jquery'

import appDisplay from 'scoreboard/components/app-display'
import FormView from 'scoreboard/components/form-view'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'

import ApiToken from './api-token'
import ApiTokenDialogView from './api-token-dialog-view'
import template from './token-creation-dialog.hbs'
import inputLengthValidatorFactory from 'scoreboard/components/validators/input-length-validator-factory'
import WsConstants from 'scoreboard/admin/model/ws-constants'
const TOKEN_NAME_MAX_LENGTH = WsConstants.TOKEN_NAME_MAX_LENGTH

/**
 * Dialog for creating a new ApiToken
 */
const TokenCreationDialog = Backbone.View.extend({
	tagName: 'form',

	render () {
		this.$el.empty().append(template())

		let nameLengthValidator = inputLengthValidatorFactory({
			high: TOKEN_NAME_MAX_LENGTH
		})

		this.labelField = new MarkedField({
			el: this.$('[name=label]'),
			validators: [requiredValidator, nameLengthValidator]
		}).render()

		this.formView = new FormView({
			el: this.el,
			submit: () => this.save()
		})

		this.formView.start()

		return this
	},

	save () {
		return $.ajax('api/admin/api-tokens', {
			method: 'post',
			data: JSON.stringify({
				label: this.labelField.val()
			}),
			success: response => {
				// Replace the current dialog with the view that displays the
				// generated token; this gives the user an opportunity to
				// copy the token
				let token = new ApiToken(response)
				appDisplay.dialog(new ApiTokenDialogView({ model: token }),
					null, { replace: true })

				// Let the ApiTokensView know that the token has been created;
				// it will add it immediately, instead of waiting for the
				// dialog to close
				this.trigger('create', token)
			},
			error: xhr => {
				this.formView.error(xhr)
			}
		})
	},

	autoRemove: true
})

export default TokenCreationDialog

TokenCreationDialog.__filename__ = 'admin/api-tokens/token-creation-dialog.js'
